/**
 * The consent question, asked once.
 *
 * Renders nothing at all when this build has no analytics configured —
 * there is no cookie to ask about, and a banner that appears anyway
 * would be asking permission for something that is not happening.
 *
 * No "accept" without an equally reachable "decline": a banner where
 * refusing takes more clicks than agreeing is not consent freely given,
 * whatever the text says. Both answers are remembered, so a reader who
 * declines is not asked on every visit.
 */

import { useState } from 'react';
import { analyticsConfigured, setConsent, storedConsent, type Consent } from '../lib/analytics';

export function CookieGate() {
  const [answered, setAnswered] = useState<Consent | null>(
    () => (analyticsConfigured() ? storedConsent() : 'denied'),
  );

  if (!analyticsConfigured() || answered) return null;

  const answer = (consent: Consent) => {
    setConsent(consent);
    setAnswered(consent);
  };

  return (
    // A region, not a dialog: nothing behind it is blocked and focus is
    // not trapped, so announcing a dialog would describe a modal the
    // reader could not find their way out of and does not have.
    <aside className="cookie-gate" aria-labelledby="cookie-gate-title">
      {/* The bar spans the viewport so it reads as part of the chrome;
          its contents line up with the page column above it. */}
      <div className="cookie-gate-inner">
        <div className="cookie-gate-text">
          <strong id="cookie-gate-title">Бисквитки за статистика</strong>
          <p>
            {'Този сайт може да използва Google Analytics, за да преброи '
             + 'колко души четат кои страници. Нищо не се зарежда и никаква '
             + 'бисквитка не се записва, докато не се съгласите. Страниците '
             + 'за лица се отчитат обобщено — псевдонимът на конкретно лице '
             + 'не се изпраща. '}
            <a href="#/privacy">Политика за поверителност</a>
          </p>
        </div>
        <div className="cookie-gate-actions">
          <button type="button" className="btn" onClick={() => answer('denied')}>
            Откажи
          </button>
          <button type="button" className="btn btn-primary" onClick={() => answer('granted')}>
            Приемам
          </button>
        </div>
      </div>
    </aside>
  );
}
